<template>
  <div class="mt-2 help-block">
    <small
      class="help-text text-grey-darkest"
      v-text="helpText"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'HelpText',
  props: {
    helpText: {
      type: String,
      required: true,
    },
  },
}
</script>
